import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-624f8e63"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "school-year" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "school-year-unit" }, "年度", -1))
const _hoisted_3 = { class: "school-type" }
const _hoisted_4 = { class: "grade-number" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "grade-number-unit" }, "年", -1))
const _hoisted_6 = { class: "name" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "name-unit" }, "組", -1))
const _hoisted_8 = {
  key: 1,
  class: "class-area"
}
const _hoisted_9 = { class: "school-year" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "school-year-unit" }, "年度", -1))
const _hoisted_11 = { class: "school-type" }
const _hoisted_12 = { class: "grade-number" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "grade-number-unit" }, "年", -1))
const _hoisted_14 = { class: "name" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "name-unit" }, "組", -1))
const _hoisted_16 = { class: "student-number" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "student-number-unit" }, "番", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: "editable-item-student-classes-item-container",
    style: _normalizeStyle(_ctx.styles)
  }, [
    (_ctx.isLink)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          class: "class-area link",
          to: _ctx.linkPath
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.studentClass.schoolYear), 1),
            _hoisted_2,
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.schoolTypeDisplayValue), 1),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.studentClass.grade.gradeNumber), 1),
            _hoisted_5,
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.className), 1),
            _hoisted_7
          ]),
          _: 1
        }, 8, ["to"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.studentClass.schoolYear), 1),
          _hoisted_10,
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.schoolTypeDisplayValue), 1),
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.studentClass.grade.gradeNumber), 1),
          _hoisted_13,
          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.className), 1),
          _hoisted_15
        ])),
    _createElementVNode("div", {
      class: _normalizeClass(["student-number-area", { 'no-value': !_ctx.hasStudentNumber }])
    }, [
      _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.studentNumberDisplayValue), 1),
      _hoisted_17
    ], 2)
  ], 4))
}